import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TestSerService {

  constructor() { }

  public log (str:string):void {
    console.log(str)
  }
}
